<template>
    <div class="toast-root" :data-placement="placement">
        <div class="toast" :data-variant="variant" role="status" aria-live="polite">
            <div class="toast__text">
                <strong v-if="title" class="toast__title">{{ title }}</strong>
                <span v-if="description" class="toast__description">{{ description }}</span>
            </div>
            <flatIconButton class="toast__close" :iconSize="16" @click="$emit('close')">
                <CloseIconSvg slot="svgIcon" />
            </flatIconButton>
        </div>
    </div>
</template>

<script>
import CloseIconSvg from '@/assets/icons/close.svg';
import flatIconButton from '@/components/ui/button/flatIconButton.vue';

const PLACEMENTS = [
    'top-left',
    'top-center',
    'top-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
];

export default {
    name: 'Toast',
    components: {
        CloseIconSvg,
        flatIconButton,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        placement: {
            type: String,
            default: 'bottom-center',
            validator: (value) => PLACEMENTS.includes(value),
        },
        variant: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'error', 'success'].includes(value),
        },
    },
}
</script>

<style scoped>
.toast-root {
    position: fixed;
    z-index: 2000;
    display: flex;
    padding: var(--spacing-xl);
    pointer-events: none;
    box-sizing: border-box;
}

.toast-root[data-placement="top-left"],
.toast-root[data-placement="top-center"],
.toast-root[data-placement="top-right"] {
    top: 0;
    left: 0;
    right: 0;
    align-items: flex-start;
}

.toast-root[data-placement="bottom-left"],
.toast-root[data-placement="bottom-center"],
.toast-root[data-placement="bottom-right"] {
    bottom: 0;
    left: 0;
    right: 0;
    align-items: flex-end;
}

.toast-root[data-placement="top-left"],
.toast-root[data-placement="bottom-left"] {
    justify-content: flex-start;
}

.toast-root[data-placement="top-center"],
.toast-root[data-placement="bottom-center"] {
    justify-content: center;
}

.toast-root[data-placement="top-right"],
.toast-root[data-placement="bottom-right"] {
    justify-content: flex-end;
}

.toast {
    display: flex;
    align-items: flex-start;
    gap: var(--spacing-md);
    max-width: 360px;
    min-width: 240px;
    padding: var(--spacing-md) var(--spacing-sl);
    background-color: var(--background-white);
    border: 1px solid var(--border-primary);
    border-radius: var(--radius-md);
    box-shadow: var(--card-box-shadow);
    pointer-events: auto;
    text-align: left;
}

.toast[data-variant="error"] {
    background-color: #FEE2E2;
    border-color: #FECACA;
}

.toast[data-variant="success"] {
    background-color: #DCFCE7;
    border-color: #BBF7D0;
}

.toast__text {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}

.toast__title {
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 600;
    line-height: var(--leading-normal);
    color: var(--color-primary);
}

.toast__description {
    font-family: var(--font-family-primary);
    font-size: var(--text-xs);
    font-weight: 400;
    line-height: var(--leading-normal);
    color: var(--color-dark-gray);
}

.toast__close {
    margin-top: 1px;
}
</style>
